import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MetricDeploymentConfig from './metric-deployment-config-model'
import {
  CreateMetricDeploymentConfigAsync,
  DeleteMetricDeploymentConfigAsync,
  LoadMetricDeploymentConfigsAsync,
} from './metricDeploymentConfig-thunk'
const initialState: metricDeploymentConfigSliceState = {
  metricDeploymentConfig: [],
  selected_metricDeploymentConfig: '',
  is_loading_metricDeploymentConfig: false,
  is_creating_metricDeploymentConfig: false,
  is_deleting_metricDeploymentConfig: false,
}
export interface metricDeploymentConfigSliceState {
  metricDeploymentConfig: MetricDeploymentConfig[]
  selected_metricDeploymentConfig?: string
  is_loading_metricDeploymentConfig: boolean
  is_creating_metricDeploymentConfig: boolean
  is_deleting_metricDeploymentConfig: boolean
}
export const metricDeploymentConfigSlice = createSlice({
  name: 'metricDeploymentConfig',
  initialState,
  reducers: {
    setSelectedmetricDeploymentConfig: (state, action) => {
      state.selected_metricDeploymentConfig = action.payload
    },
    clearStatemetricDeploymentConfig: (state) => {
      state.metricDeploymentConfig = []
      state.is_loading_metricDeploymentConfig = false
      state.is_creating_metricDeploymentConfig = false
      state.is_deleting_metricDeploymentConfig = false
    },
    mergemetricDeploymentConfig: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricDeploymentConfig = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricDeploymentConfig = merge(
            state.metricDeploymentConfig,
            payload,
          ) as any
        }
      }
    },

    add_metricDeploymentConfig: (state, action) => {
      if (action.payload) {
        state.metricDeploymentConfig = [
          ...state.metricDeploymentConfig,
          action.payload,
        ]
      }
    },
    set_metricDeploymentConfig: (state, action) => {
      let { key, value, id } = action.payload
      state.metricDeploymentConfig = state.metricDeploymentConfig.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricDeploymentConfigsAsync.pending, (state) => {
      state.is_loading_metricDeploymentConfig = true
    })
    builder.addCase(
      LoadMetricDeploymentConfigsAsync.fulfilled,
      (state, action) => {
        state.is_loading_metricDeploymentConfig = false
        if (action.payload) {
          state.metricDeploymentConfig = action.payload
        }
      },
    )
    builder.addCase(LoadMetricDeploymentConfigsAsync.rejected, (state) => {
      state.is_loading_metricDeploymentConfig = false
    })
    builder.addCase(CreateMetricDeploymentConfigAsync.pending, (state) => {
      state.is_creating_metricDeploymentConfig = true
    })
    builder.addCase(CreateMetricDeploymentConfigAsync.fulfilled, (state) => {
      state.is_creating_metricDeploymentConfig = false
    })
    builder.addCase(CreateMetricDeploymentConfigAsync.rejected, (state) => {
      state.is_creating_metricDeploymentConfig = false
    })
    builder.addCase(DeleteMetricDeploymentConfigAsync.pending, (state) => {
      state.is_deleting_metricDeploymentConfig = true
    })
    builder.addCase(
      DeleteMetricDeploymentConfigAsync.fulfilled,
      (state, action) => {
        state.is_deleting_metricDeploymentConfig = false
        if (state.metricDeploymentConfig) {
          state.metricDeploymentConfig = state.metricDeploymentConfig.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteMetricDeploymentConfigAsync.rejected, (state) => {
      state.is_deleting_metricDeploymentConfig = false
    })
  },
})

export const {
  clearStatemetricDeploymentConfig,
  setSelectedmetricDeploymentConfig,
  set_metricDeploymentConfig,
  mergemetricDeploymentConfig,
  add_metricDeploymentConfig,
} = metricDeploymentConfigSlice.actions

export const get_metricDeploymentConfig =
  (id?: string) =>
  (state: {
    metricDeploymentConfig: {
      metricDeploymentConfig: MetricDeploymentConfig[]
    }
  }): MetricDeploymentConfig | null => {
    let temp = state?.metricDeploymentConfig?.metricDeploymentConfig?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.metricDeploymentConfig?.metricDeploymentConfig[0] || null
  }
export const get_selected_metricDeploymentConfig = (state: {
  metricDeploymentConfig: metricDeploymentConfigSliceState
}): MetricDeploymentConfig | null => {
  let id = state?.metricDeploymentConfig?.selected_metricDeploymentConfig
  let temp = state?.metricDeploymentConfig?.metricDeploymentConfig?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricDeploymentConfig = (state: {
  metricDeploymentConfig: {
    metricDeploymentConfig: MetricDeploymentConfig[]
  }
}): MetricDeploymentConfig[] => {
  let temp = state?.metricDeploymentConfig?.metricDeploymentConfig
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricDeploymentConfig_busy = (state: {
  metricDeploymentConfig: metricDeploymentConfigSliceState
}) => {
  return (
    state?.metricDeploymentConfig.is_deleting_metricDeploymentConfig ||
    state?.metricDeploymentConfig.is_loading_metricDeploymentConfig ||
    state?.metricDeploymentConfig.is_creating_metricDeploymentConfig
  )
}
export const is_deleting_metricDeploymentConfig_busy = (state: {
  metricDeploymentConfig: metricDeploymentConfigSliceState
}) => {
  return state?.metricDeploymentConfig.is_deleting_metricDeploymentConfig
}
export const is_loading_metricDeploymentConfig_busy = (state: {
  metricDeploymentConfig: metricDeploymentConfigSliceState
}) => {
  return state?.metricDeploymentConfig.is_loading_metricDeploymentConfig
}
export const is_creating_metricDeploymentConfig_busy = (state: {
  metricDeploymentConfig: metricDeploymentConfigSliceState
}) => {
  return state?.metricDeploymentConfig.is_creating_metricDeploymentConfig
}

export default metricDeploymentConfigSlice.reducer
